
import GLightbox from "glightbox";

// Only code specific to this site should be here. Anything that can be used across multiple sites
// should be pushed into the KMS.

export function init() {
	setupMapClick();
	countUpByClass("counter");
	scrollAnimation();
	GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: true
	});
}

export function scrollAnimation() {
	const observer = new IntersectionObserver((entries) => {
		let delay = 0; // default delay for elements without reset-fade class
		entries.forEach(entry => {
			const el = entry.target;

			if (entry.isIntersecting) {
				if (el.classList.contains("reset-fade")){
					delay = 0; // reset delay for elements with reset-fade class
				}
				else
				{
					delay = delay + 200; // 100ms between each element
				}
				el.style.transitionDelay = `${delay}ms`;
				entry.target.classList.add("visible");
				observer.unobserve(el);

			}
			// else{
			// 	el.style.transitionDelay = "0ms"; // reset delay

			// 	entry.target.classList.remove("visible");
			// }
		});
	}, {
		threshold: 0.25 // You can tweak this for sensitivity
	});

	document.querySelectorAll(".fade-in-element").forEach(el => {
		observer.observe(el);
	});
}

export function setupMapClick(){
	const map_click_list = document.querySelectorAll("#map-click, .map-click");
	if (map_click_list) {
		map_click_list.forEach((map_click) => {
			map_click.addEventListener("click", () => {
				// shield the map on mobile for easy scrolling
				map_click.style.display = "none";
			});
		});
	}
}

export function countUpByClass(className) {
	const counters = document.querySelectorAll(`.${className}`);
	
	const animate = (el) => {
		const target = parseInt(el.textContent, 10); // Get initial value from HTML
		const duration = 2000; // Optional duration from data-attribute
		let start = 0;
		const stepTime = Math.abs((duration / target));
		let step_multiplier = target / 1000;
		if (step_multiplier < 1){
			step_multiplier = 1;
		}
		console.log(target, stepTime, step_multiplier);
		function updateCounter() {
			start = start + step_multiplier;
			el.textContent = start.toLocaleString();
			if (start < target) {
				setTimeout(updateCounter, stepTime);
			}
		}
		updateCounter();
	};

	function onElementInView(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				animate(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}

	const observer = new IntersectionObserver(onElementInView, {
		root: null,  // viewport
		rootMargin: "0px",
		threshold: 0.1 // Trigger when 10% of the element is visible
	});

	counters.forEach((counter) => {
		observer.observe(counter);
	});
}


window.addEventListener("DOMContentLoaded", init);